<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ชื่อหมวดหมู่ :</label>
                <span class="form-control-plaintext">{{ delFolderName }}</span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ผู้สร้าง :</label>
                <span class="form-control-plaintext">{{ delCreateBy }}</span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ลำดับหมวดหมู่ :</label>
                <span class="form-control-plaintext"></span>
                <template v-for="item in delParentLink">
                  <a
                    v-if="item.folderElearningId != id"
                    href="#"
                    @click.prevent="GotoParent(item.folderElearningId)"
                    >{{ item.folderName }} >
                  </a>
                  <a
                    v-else
                    href="#"
                    @click.prevent="GotoParent(item.folderElearningId)"
                    >{{ item.folderName }}</a
                  >
                </template>

                <!-- <a href="#" @click.prevent="GotoParent(parentLink.folderElearningId)">{{parentLink.folderName}} > </a> -->
                <!-- <span class="form-control-plaintext">{{delParentLink}}</span> -->
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วันที่สร้าง :</label>
                <span class="form-control-plaintext">{{ delCreateDate }}</span>
              </div>
            </div>
          </div>
          <!-- Begin: status checkbox -->
          <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
            <div class="form-group">
              <label>สถานะ:</label>
              <div class="form-check">
                <label class="form-check-label kt-checkbox">
                  <input
                    id="buStatus"
                    name="buStatus"
                    v-model="delStatus"
                    type="checkbox"
                    class="form-check-input"
                    disabled
                  />
                  เปิดใช้งาน
                  <span></span>
                </label>
              </div>
            </div>
          </div>
          <!-- End: status checkbox -->

          <!-- Begin:Picture element -->
          <div
            v-if="this.$root.canShow(['ADMIN_5S', 'MANAGER_5S'])"
            class="row"
          >
            <div class="col-xl-8">
              <div class="form-group">
                <label>ไฟล์:</label>
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  id="uploader-order"
                  :data-ref="uuid"
                >
                  <i class="flaticon-upload-1"></i>เลือกไฟล์
                </button>
                <button
                  v-if="IsShowUploadBtn"
                  type="button"
                  class="btn btn-success m-btn--pill btn-block col-xl-2"
                  @click.prevent="UploadFile"
                >
                  <i class="fas fa-cloud-upload-alt"></i>อัพโหลดไฟล์
                </button>
                <div class="row" id="container-file"></div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <div class="row mb-3">
            <div class="col-xl-12 text-right">
              <button
                type="button"
                class="btn btn-outline-info"
                @click.prevent="AddSub"
                v-if="
                  this.$root.canShow(['ADMIN_5S', 'MANAGER_5S']) &&
                    delFolderLevel < 5
                "
              >
                <i class="fa fa-folder-plus"></i>เพิ่มหมวดหมู่ย่อย
              </button>
              <!-- <router-link
                  to="E-Learning/AddSubFolder"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow([''])"
                  >
                    <i class="fa fa-plus-circle"></i> เพิ่มหมวดหมู่ย่อย
                  </router-link> -->
            </div>
          </div>

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการ:</h3>
            <div class="kt-section__body">
              <div class="row">
                <!--begin: Datatable -->
                <div class="col-lg-12 table-responsive">
                  <table
                    class="table-sm table-striped- table-bordered table-hover table-checkable"
                    id="folderDetilsTable"
                    refs="folderDetilsTable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="20%">ชื่อ</th>
                        <th class="text-center" width="7%">วันที่บันทึกล่าสุด</th>
                        <th class="text-center" width="7%">จำนวนการเข้าดู</th>
                        <th class="text-center" width="15%">การจัดการ</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <!--end: Datatable -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click.prevent="Goback"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../router";
import plupload from "plupload";

let Action = Vue.extend({
  template: `
  <div>
    <a :href="'/Api/FileElearning/FileStream/' + data.folderAndFileId" @click.prevent="Play" v-if="data.showPlayButton" title="เล่น" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info fas fa-play"></i>
    </a>
    <a href="#" @click.prevent="download" v-if="data.showDownloadButton" title="ดาวน์โหลด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info fas fa-download"></i>
    </a>
    <a href="#" @click.prevent="edit" v-if="data.showEditFolderButton" title="เปลี่ยนชื่อหมวดหมู่" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info la la-pencil"></i>
    </a>
    <a href="#" @click.prevent="editFile" v-if="data.showEditFileButton" title="เปลี่ยนชื่อไฟล์" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info la la-pencil"></i>
    </a>
    <a :href="'/5S/E-Learning/Detials/' + data.folderAndFileId" @click.prevent="Details" v-if="data.showDetailsButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info far fa-folder-open"></i>
    </a>
    <a href="#" @click.prevent="Delete" v-if="data.showDeletesFolderButton" title="ลบหมวดหมู่" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-danger fas fa-trash-alt"></i>
    </a>
    <a href="#" @click.prevent="DeleteFile" v-if="data.showDeletesFileButton" title="ลบไฟล์" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-danger fas fa-trash-alt"></i>
    </a>
  </div>`,
  methods: {
    Play: function() {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "get",
        url: "/Api/FileElearning/FileStream/" + self.data.folderAndFileId,
      })
        .then(function(response) {
          if (response.status == "200") {
            //window.open(response.data);
            window.open(
              response.data,
              "_blank",
              "location=yes,height=500,width=600,scrollbars=no,status=yes"
            );
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "", "warning");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          self.$parent.reloadDataTable();
          KTApp.unblockPage();
        });
    },
    download: function() {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "get",
        url: "/Api/FileElearning/" + self.data.folderAndFileId,
        responseType: "arraybuffer",
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              //console.log(matches);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            let blob = new Blob([response.data], { type: contentType }),
              url = window.URL.createObjectURL(blob);

            let browserOpen = ["jpg", "jpeg", "png", "gif", "pdf"];
            if (browserOpen.includes(self.data.contentType)) {
              var nAgt = navigator.userAgent;
              if(nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/'))
              {
                window.open(url);
              }
              else
              {
                if (window.navigator.msSaveOrOpenBlob) 
                {
                  window.navigator.msSaveBlob(blob, filename);
                }
              }
            } else {
              
              var nAgt = navigator.userAgent;
              if(nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/'))
              {
                let a = $("<a />", {
                  href: url,
                  download: decodeURIComponent(filename),
                })
                  .appendTo("body")
                  .get(0)
                  .click();
              }
              else
              {
                if (window.navigator.msSaveOrOpenBlob) 
                {
                  window.navigator.msSaveBlob(blob, filename);
                }
              }
            }
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          self.$parent.reloadDataTable();
          KTApp.unblockPage();
        });
    },
    edit: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อหมวดหมู่ย่อย",
        type: "info",
        html: "กรุณาระบุชื่อหมวดหมู่ย่อย <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อหมวดหมู่ย่อย");
          }
        },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder", {
              FolderElearningId: this.data.folderAndFileId,
              FolderName: result.value,
            })
            .then(function(response) {
              if (response.data.status == true) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    editFile: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อไฟล์",
        type: "info",
        html: "กรุณาระบุชื่อไฟล์ <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อไฟล์");
          }
        },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });

          axios
            .put("/Api/FileElearning", {
              FileElearningId: this.data.folderAndFileId,
              FileName: result.value,
            })
            .then(function(response) {
              if (response.data.status == true) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    Details: function() {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      router.push({
        path: `/5S/E-Learning/Detials/${self.data.folderAndFileId}`,
      });
      self.$parent.id = self.data.folderAndFileId;
      self.$parent.reloadDataTableChangeParam(false);
    },
    Delete: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลหมวดหมู่ย่อย",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลหมวดหมู่ย่อย <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลหมวดหมู่ย่อยไม่ถูกใช้งาน",
        inputPlaceholder: "ต้องการลบข้อมูลหมวดหมู่ย่อย",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder/" + this.data.folderAndFileId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    DeleteFile: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบไฟล์",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคำสั่งลบไฟล์ <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/FileElearning/" + this.data.folderAndFileId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let ActionUrlFile = Vue.extend({
  template: `
  <div>
    <a :href="'/Api/FileElearning/' + data.folderAndFileId" @click.prevent="download"  v-if="data.contentTypeGroup == 'file-image'" title="ดาวน์โหลด" >
      <i class="text-info fas fa-file-image"></i> {{data.folderAndFileName}}
    </a>
    <a :href="'/Api/FileElearning/' + data.folderAndFileId" @click.prevent="download"  v-if="data.contentTypeGroup == 'file-power-point'" title="ดาวน์โหลด" >
      <i class="text-info fas fa-file-powerpoint"></i> {{data.folderAndFileName}}
    </a>
    <a :href="'/Api/FileElearning/' + data.folderAndFileId" @click.prevent="download"  v-if="data.contentTypeGroup == 'file-pdf'" title="ดาวน์โหลด" >
      <i class="text-info fas fa-file-pdf"></i> {{data.folderAndFileName}}
    </a>
    <a :href="'/Api/FileElearning/' + data.folderAndFileId" @click.prevent="download"  v-if="data.contentTypeGroup == 'file-excel'" title="ดาวน์โหลด" >
      <i class="text-info fas fa-file-excel"></i> {{data.folderAndFileName}}
    </a>
    <a :href="'/Api/FileElearning/' + data.folderAndFileId" @click.prevent="download"  v-if="data.contentTypeGroup == 'file-word'" title="ดาวน์โหลด" >
      <i class="text-info fas fa-file-word"></i> {{data.folderAndFileName}}
    </a>

    <a :href="'/Api/FileElearning/FileStream/' + data.folderAndFileId" @click.prevent="Play" v-if="data.contentTypeGroup == 'file-video'" title="เล่น">
      <i class="text-info fas fa-play"></i> {{data.folderAndFileName}}
    </a>
  </div>`,
  methods: {
    Play: function() {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "get",
        url: "/Api/FileElearning/FileStream/" + self.data.folderAndFileId,
      })
        .then(function(response) {
          if (response.status == "200") {
            //window.open(response.data);
            window.open(
              response.data,
              "_blank",
              "location=yes,height=500,width=600,scrollbars=no,status=yes"
            );
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "", "warning");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          self.$parent.reloadDataTable();
          KTApp.unblockPage();
        });
    },

    download: function() {
      let self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });
      console.log('get download 2',self.data)

      axios({
        method: "get",
        url: "/Api/FileElearning/" + self.data.folderAndFileId,
        responseType: "arraybuffer",
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              //console.log(matches);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            let blob = new Blob([response.data], { type: contentType }),
              url = window.URL.createObjectURL(blob);

            let browserOpen = ["jpg", "jpeg", "png", "gif", "pdf"];
            if (browserOpen.includes(self.data.contentType)) {
              var nAgt = navigator.userAgent;
              if(nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/'))
              {
                window.open(url);
              }
              else
              {
                if (window.navigator.msSaveOrOpenBlob) 
                {
                  window.navigator.msSaveBlob(blob, filename);
                }
              }
            } else {
              
              var nAgt = navigator.userAgent;
              if(nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/'))
              {
                let a = $("<a />", {
                  href: url,
                  download: decodeURIComponent(filename),
                })
                  .appendTo("body")
                  .get(0)
                  .click();
              }
              else
              {
                if (window.navigator.msSaveOrOpenBlob) 
                {
                  window.navigator.msSaveBlob(blob, filename);
                }
              }
            }
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          self.$parent.reloadDataTable();
          KTApp.unblockPage();
        });
    }
  },
});

export default {
  data() {
    var self = this;
    return {
      uuid: null,
      FileUpload: null,
      delFilename: null,
      delFolderName: null,
      delFolderId: null,
      delParentFolderId: null,
      delCreateDate: null,
      delCreateBy: null,
      delStatus: false,
      delItems: [],
      IsShowUploadBtn: false,
      delFolderLevel: 0,
      id: null,
      delParentLink: null,
    };
  },
  methods: {
    reloadDataTable: function(resetPaging = false) {
      $("#folderDetilsTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    reloadDataTableChangeParam: function(resetPaging = false) {
      $("#folderDetilsTable")
        .DataTable()
        .ajax.url("/Api/Folder/" + this.id)
        .load();
      // $("#folderDetilsTable")
      //   .DataTable()
      //   .ajax.reload(null, resetPaging);
    },
    AddSub() {
      let router = this.$router;
      let self = this;
      router.push({
        path: `/5S/E-Learning/Detials/${self.delFolderId}/AddSubFolder`,
      });
    },
    GotoParent(id) {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      router.push({
        path: `/5S/E-Learning/Detials/${id}`,
      });
      self.id = id;
      self.reloadDataTableChangeParam(false);
    },
    Goback() {
      let self = this;
      if (self.delParentFolderId != null) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
        });

        self.$router.push({
          path: `/5S/E-Learning/Detials/${self.delParentFolderId}`,
        });
        self.id = self.delParentFolderId;
        self.reloadDataTableChangeParam(false);
      } else {
        //this.$router.go(-1)

        self.$router.push(`/5S/E-Learning`);
      }
    },
    GetContentType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      const allowedExtensions = [
        "jpg", "jpeg", "png", "pdf", "xlsx", "xls",
        "doc", "docx", "mp4", "avi", "ppt", "pptx"
      ];

      return allowedExtensions.includes(extension) ? extension : "unknown";
    },
    initPlUploader() {
      let self = this;
      self.uuid = this._uid;

      var uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        browse_button: "uploader-order",
        url: "#",
        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "1024mb",
          mime_types: [
            {
              title: "doc files",
              extensions: "jpg,jpeg,png,pdf,xlsx,xls,doc,docx,mp4,avi,ppt,pptx",
            },
          ],
        },
        init: {
          PostInit: function() {},
          FilesAdded: function(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            var removeFiles = [];
            plupload.each(files, function(file) {
              self.delFilename = file.name;
              if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                var nativeData = file.getNative();

                if (files[0]) {
                  var contentType = self.GetContentType(file.name);
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    contentType: contentType,
                    fileId: file.id,
                    fileName: file.name,
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $(
                    '<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' +
                    file.id +
                    '"></div>'
                  );
                  $(
                    '<div style="display:none" id="files" data-file-id="' +
                    file.id +
                    '" data-file-name="' +
                    file.name +
                    '" data-file-uploaded="false" alt="' +
                    file.name +
                    '">' +
                    file.name +
                    '<div id="myProgress" class="progress' +
                    file.id +
                    '"><div id="myBar" class="progress-bar bg-ptimary"><b></b></div ></div></div>'
                  ).appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    $("div[data-file-id=" + file.id + "]")
                      .attr("src", e.target.result)
                      .show();
                  };
                  reader.readAsDataURL(nativeData);
                  self.mockProgress(file.id);
                }
              } else {
                removeFiles.push(file);
              }
            });
            if (removeFiles.length > 0) {
              for (var i = 0; i < removeFiles.length; i++) {
                up.removeFile(removeFiles[i]);
              }
              swal("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
            }
          },
          UploadProgress: function(up, file) {
          },
          FileUploaded: function(up, file, info) {
            console.log("FileUploaded");
          },
          Error: function(up, err) {
            console.log(err);
            swal("Error", "เกิดข้อผิดพลาด: " + err.message, "error");
          },
        },
      });

      uploader.init();
    },
    mockProgress(fileId) {
      let progress = 0;
      let interval = setInterval(() => {
        progress += 50;
        if (progress <= 100) {
          $('#myBar').css('width', progress + '%');
          document
            .getElementById(fileId)
            .getElementsByTagName("b")[0].innerHTML = "<span>" + progress + "%</span>";
        } else {
          clearInterval(interval);
          this.IsShowUploadBtn = true;
        }
      }, 10);
    },
    async UploadFile(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังอัพโหลด กรุณารอสักครู่...",
      });

      let uploadedFile = null;

      if ( this.FileUpload && this.FileUpload.isNew && this.FileUpload.fileDataContext ) {
        try {
          const file = this.FileUpload;
          const formData = new FormData();
          formData.append("File", file.fileDataContext);
          formData.append("IsMaster", true);
          formData.append("FolderName", "Elearning");

          const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          uploadedFile = {
            contentType: file.contentType || "-",
            downloadUrl: uploadResponse.data.fileUrl,
            fileInfoId: uploadResponse.data.fileInfoId,
            fileName: file.fileName,
            gridFsId: uploadResponse.data.gridFsId,
            sysName: "-",
          };
        } catch (error) {
          console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
        }
      }

      axios({
        method: "post",
        url: "/Api/FileElearning",
        data: {
          folderElearningId: self.delFolderId,
          fileName: uploadedFile.fileName,
          fileDescription: null,
          fileUpload: uploadedFile
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                self.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          //Clear brows file
          self.IsShowUploadBtn = false;
          var $imageContainer = $("#container-file");
          $imageContainer.empty();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    var table = $("#folderDetilsTable");
    self.initPlUploader();
    self.id = this.$route.params.id;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    // begin first table
    table
      .DataTable({
        responsive: true,
        //processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Folder/" + self.id, // "/Api/Folder/Search",
          type: "get",
          //dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //console.log(d);
            // return JSON.stringify(
            //   $.extend(d, {
            //     SearchKeyword: self.melKeyword,
            //     SearchInActiveStatus: self.melInActiveStatus
            //   })
            // );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12'tr>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[2, "desc"]],
        columns: [
          {
            data: "folderAndFileName",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "folderAndFileName",
            render: function(data, type, full, meta) {
              //If file
              if (full.isItemFile) {
                
                if (full.contentTypeGroup == "file-video") {
                  return '<div class="actionsName"></div>';
                  // return "<i class='fas fa-file-video'> " + data;
                } else if (full.contentTypeGroup == "file-image") {
                  return '<div class="actionsName"></div>';
                    // "<i class='fas fa-file-image'></i> " + data;
                } else if (full.contentTypeGroup == "file-pdf") {
                  return '<div class="actionsName"></div>';
                  // return "<i class='fas fa-file-pdf'></i> " + data;
                } else if (full.contentTypeGroup == "file-excel") {
                  return '<div class="actionsName"></div>';
                  // return "<i class='fas fa-file-excel'></i> " + data;
                } else if (full.contentTypeGroup == "file-word") {
                  return '<div class="actionsName"></div>';
                  // return "<i class='fas fa-file-word'></i> " + data;
                }else if (full.contentTypeGroup == "file-power-point") {
                  return '<div class="actionsName"></div>';
                    // "<i class='fas fa-file-image'></i> " + data;
                }else {
                  return data;
                }
              }
              //If folder
              else {
                return (
                  '<a href="/5S/E-Learning/Detials/' +
                  full.folderAndFileId +
                  '" title="รายละเอียด"><i class="text-info far fa-folder-open">' +
                  data +
                  "</i></a>"
                );
                //return "<i class='fas fa-folder'></i> " + data;
              }
            },
          },
          {
            data: "folderAndFileId",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createdDateFormat;
            },
          },
          {
            data: "viewed",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.isItemFile) {
                return data;
              } else {
                return "";
              }
            },
          },
          {
            data: "folderAndFileId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
        drawCallback: function(settings) {
          KTApp.unblockPage();
          self.delFolderName = settings.json.folderName;
          self.delFolderId = settings.json.folderElearningId;
          self.delCreateDate = settings.json.createdDateFormat;
          self.delCreateBy = settings.json.createdBy;
          self.delItems = settings.json.itemsCombine;
          self.delStatus = !settings.json.inActiveStatus;
          self.delParentFolderId = settings.json.parentFolderElearningId;
          self.delFolderLevel = settings.json.folderLevel;
          self.delParentLink = settings.json.parents;
        },
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showDownloadButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning",]) && data.isItemFile && data.contentTypeGroup != "file-video";
            data.showPlayButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning",]) && data.isItemFile && data.contentTypeGroup == "file-video";
            data.showEditFolderButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && !data.isItemFile;
            data.showEditFileButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && data.isItemFile;
            data.showDeletesFolderButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && !data.isItemFile;
            data.showDeletesFileButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && data.isItemFile;
            data.showDetailsButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning",]) && !data.isItemFile;
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
        $(".actionsName").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionUrlFile({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/5S/DetialsELearning.vue